import { Injector, inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';

export const redirectAuthenticatedGuard: CanMatchFn = async (): Promise<boolean | UrlTree> => {
  const injector = inject(Injector);
  const router = inject(Router);

  const { AuthService } = await import('@core/services/auth/auth.service');
  const auth = injector.get(AuthService);

  // Reflect cookie-based session, without calling getSession every navigation.
  await auth.ensureSessionFresh();

  return auth.isAuthenticated() ? router.createUrlTree(['/overview']) : true;
};
